/**
 * Calcule l'année scolaire en cours
 * L'année scolaire commence le 1er septembre
 * 
 * Exemples:
 * - Décembre 2024 → 2024-2025
 * - Janvier 2025 → 2024-2025
 * - Août 2025 → 2024-2025
 * - Septembre 2025 → 2025-2026
 */
export function getCurrentSchoolYear(): string {
  const now = new Date()
  const currentYear = now.getFullYear()
  const currentMonth = now.getMonth() + 1 // 0-11 → 1-12

  // Si on est entre septembre (9) et décembre (12), l'année scolaire est currentYear - (currentYear+1)
  // Si on est entre janvier (1) et août (8), l'année scolaire est (currentYear-1) - currentYear
  if (currentMonth >= 9) {
    // Septembre à décembre
    return `${currentYear}-${currentYear + 1}`
  } else {
    // Janvier à août
    return `${currentYear - 1}-${currentYear}`
  }
}

/**
 * Calcule l'année scolaire suivante
 */
export function getNextSchoolYear(): string {
  const current = getCurrentSchoolYear()
  const [startYear] = current.split('-').map(Number)
  return `${startYear + 1}-${startYear + 2}`
}

/**
 * Calcule l'année scolaire précédente
 */
export function getPreviousSchoolYear(): string {
  const current = getCurrentSchoolYear()
  const [startYear] = current.split('-').map(Number)
  return `${startYear - 1}-${startYear}`
}

/**
 * Génère une liste d'années scolaires
 * @param count Nombre d'années à générer (par défaut 5)
 * @param includeNext Inclure les années futures (par défaut true)
 */
export function getSchoolYearList(count: number = 5, includeNext: boolean = true): string[] {
  const current = getCurrentSchoolYear()
  const [startYear] = current.split('-').map(Number)
  const years: string[] = []

  // Années passées + actuelle
  for (let i = count - 1; i >= 0; i--) {
    const year = startYear - i
    years.push(`${year}-${year + 1}`)
  }

  // Année suivante si demandée
  if (includeNext) {
    years.push(`${startYear + 1}-${startYear + 2}`)
  }

  return years
}
